import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed, inject, reactive, ref } from "vue";
import { useAnimationFrameSize } from "@/composables/sensors/animationFrameSize";
import { useAnimationFrameThrottle } from "@/composables/throttle";
import { useWorkflowStores } from "@/composables/workflowStores";
import { useDraggable } from "./composables/useDraggable.js";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Draggable',
    props: {
        rootOffset: {
            type: Object,
            required: true,
        },
        preventDefault: {
            type: Boolean,
            default: true,
        },
        stopPropagation: {
            type: Boolean,
            default: true,
        },
        dragData: {
            type: Object,
            required: false,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        snappable: {
            type: Boolean,
            default: true,
        },
    },
    emits: ["mousedown", "mouseup", "move", "dragstart", "start", "stop"],
    setup(__props, { emit }) {
        const props = __props;
        let dragImg = null;
        const draggable = ref();
        const size = reactive(useAnimationFrameSize(draggable));
        const transform = inject("transform");
        const { throttle } = useAnimationFrameThrottle();
        let dragging = false;
        const onStart = (_position, event) => {
            emit("start");
            emit("mousedown", event);
            if (event.type == "dragstart") {
                dragImg = document.createElement("img");
                dragImg.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
                document.body.appendChild(dragImg);
                // I guess better than copy ?
                event.dataTransfer.effectAllowed = "link";
                try {
                    event.dataTransfer.setDragImage(dragImg, 0, 0);
                }
                catch (e) {
                    console.error(e);
                }
                if (props.dragData) {
                    event.dataTransfer.setData("text/plain", JSON.stringify(props.dragData));
                }
                emit("dragstart", event);
            }
        };
        const { toolbarStore } = useWorkflowStores();
        const { snapActive } = storeToRefs(toolbarStore);
        function getSnappedPosition(position) {
            if (props.snappable && snapActive.value) {
                return Object.assign(Object.assign({}, position), { x: Math.round(position.x / toolbarStore.snapDistance) * toolbarStore.snapDistance, y: Math.round(position.y / toolbarStore.snapDistance) * toolbarStore.snapDistance });
            }
            else {
                return Object.assign(Object.assign({}, position), { x: position.x, y: position.y });
            }
        }
        const onMove = (position, event) => {
            dragging = true;
            if (event.type == "drag" && event.x == 0 && event.y == 0) {
                // the last drag event has no coordinate ... this is obviously a hack!
                return;
            }
            throttle(() => {
                if (dragging) {
                    const newPosition = {
                        unscaled: Object.assign(Object.assign({}, position), size),
                        x: (position.x - props.rootOffset.x - transform.value.x) / transform.value.k,
                        y: (position.y - props.rootOffset.y - transform.value.y) / transform.value.k,
                    };
                    emit("move", getSnappedPosition(newPosition), event);
                }
            });
        };
        const onEnd = (_position, event) => {
            if (dragImg) {
                document.body.removeChild(dragImg);
                dragImg = null;
            }
            dragging = false;
            emit("mouseup", event);
            emit("stop");
        };
        const maybeDraggable = computed(() => (props.disabled ? null : draggable.value));
        useDraggable(maybeDraggable, {
            preventDefault: props.preventDefault,
            stopPropagation: props.stopPropagation,
            useCapture: false,
            onStart: onStart,
            onMove: onMove,
            onEnd: onEnd,
        });
        return { __sfc: true, props, emit, dragImg, draggable, size, transform, throttle, dragging, onStart, toolbarStore, snapActive, getSnappedPosition, onMove, onEnd, maybeDraggable };
    }
});
